import { LegalPage, H, P, LI } from "@/components/site/Legal";

export default function Terms() {
  return (
    <LegalPage title="Terms & Conditions" updated="June 2026" testId="terms-page">
      <P>
        These Terms & Conditions ("Terms") govern your use of PinQuests.com and related services
        (the "Service"), operated by PinQuests ("we," "us," "our"). By accessing or using the Service,
        you agree to these Terms. If you do not agree, do not use the Service.
      </P>

      <H>1. The Service</H>
      <P>
        PinQuests lets creators build location-based quests consisting of clues tied to geographic
        locations, and lets players solve those clues by selecting a location on a map or submitting
        their device's current location. PinQuests is an entertainment and storytelling platform — it
        is not a navigation, tracking, or safety service.
      </P>

      <H>2. Eligibility and Accounts</H>
      <ul>
        <LI>You must be at least 13 years old to create an account, and at least 18 (or the age of majority where you live) to create quests.</LI>
        <LI>Minors may participate in quests only with the consent and supervision of a parent or legal guardian.</LI>
        <LI>You are responsible for the accuracy of your account information and for all activity under your account.</LI>
      </ul>

      <H>3. Safety — Read This Section Carefully</H>
      <P>
        Quests may encourage visiting real-world locations. You are solely responsible for your own
        safety and judgment when playing.
      </P>
      <ul>
        <LI>Never trespass. Only visit locations that are open and lawful for you to access.</LI>
        <LI>Never enter unsafe areas, cross private property, take risks near roads, water, cliffs, or hazards, or play while driving.</LI>
        <LI>You never need to physically visit a location — every eligible clue can be solved by dropping a pin on the map instead.</LI>
        <LI>Parents and guardians must review quests before allowing minors to play, and must supervise minors during any real-world play.</LI>
        <LI>If any quest asks you to go somewhere that feels unsafe or inappropriate, stop playing and report it to us immediately.</LI>
      </ul>
      <P>
        Creators must select targets that are publicly and lawfully accessible and must not create
        quests that direct players to dangerous, restricted, or inappropriate locations.
      </P>

      <H>4. User Content</H>
      <ul>
        <LI>You retain ownership of content you upload (photos, videos, audio, text). You grant us a limited license to host, store, and display it solely to operate the Service.</LI>
        <LI>You must own or have rights to all content you upload, including rights to any people appearing in it.</LI>
        <LI>We may remove content or suspend accounts that violate these Terms.</LI>
      </ul>

      <H>5. Prohibited Conduct</H>
      <ul>
        <LI>Using the Service to harass, stalk, track, deceive, or endanger any person.</LI>
        <LI>Creating quests intended to lure any person to any location for a harmful, unlawful, or deceptive purpose.</LI>
        <LI>Uploading unlawful, infringing, hateful, sexually exploitative, or otherwise objectionable content.</LI>
        <LI>Attempting to access other users' quests, media, coordinates, or data without authorization; scraping; probing; or circumventing security or the 24-hour privacy delay.</LI>
        <LI>Impersonating others or misrepresenting your affiliation.</LI>
      </ul>
      <P>
        We reserve the right to review, verify, restrict, or remove any quest — and public quests may
        be required to pass review before becoming available.
      </P>

      <H>6. Location Data and Privacy</H>
      <P>
        Our handling of location information, the 24-hour creator delay, and guess-method
        confidentiality are described in our Privacy Policy, which is incorporated into these Terms.
        A submitted coordinate never proves physical presence, and the Service must not be used or
        represented as a tool to verify anyone's whereabouts.
      </P>

      <H>7. Disclaimers</H>
      <P>
        THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING FITNESS FOR A PARTICULAR PURPOSE, ACCURACY OF MAP DATA OR GPS READINGS, OR
        UNINTERRUPTED AVAILABILITY. PINQUESTS DOES NOT INSPECT, GUARANTEE, OR ASSUME RESPONSIBILITY FOR
        ANY REAL-WORLD LOCATION FEATURED IN ANY QUEST, INCLUDING QUESTS CREATED BY THIRD PARTIES.
      </P>

      <H>8. Limitation of Liability</H>
      <P>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, PINQUESTS AND ITS OFFICERS, EMPLOYEES, AND PARTNERS
        SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
        OR FOR ANY PERSONAL INJURY, PROPERTY DAMAGE, OR LOSS ARISING FROM YOUR TRAVEL TO OR PRESENCE AT
        ANY PHYSICAL LOCATION IN CONNECTION WITH THE SERVICE. OUR TOTAL LIABILITY FOR ANY CLAIM SHALL
        NOT EXCEED THE GREATER OF $100 OR THE AMOUNT YOU PAID US IN THE PRIOR 12 MONTHS.
      </P>

      <H>9. Indemnification</H>
      <P>
        You agree to indemnify and hold PinQuests harmless from claims arising out of your content,
        your quests, your violation of these Terms, or your violation of any law or third-party right.
      </P>

      <H>10. Termination</H>
      <P>
        You may stop using the Service at any time. We may suspend or terminate access for conduct that
        violates these Terms or threatens the safety of users or the platform.
      </P>

      <H>11. Changes to the Service and Terms</H>
      <P>
        PinQuests is in active development. Features may change, and we may update these Terms; material
        changes will be posted here with a revised date. Continued use after changes constitutes acceptance.
      </P>

      <H>12. Governing Law</H>
      <P>
        These Terms are governed by the laws of the United States and the state in which PinQuests is
        organized, without regard to conflict-of-law principles.
      </P>

      <H>13. Contact</H>
      <P>Questions about these Terms? Contact legal@pinquests.com.</P>
    </LegalPage>
  );
}
